"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SectionMain = void 0;
var _analyticsData = require("@ori/analytics-data");
var _basketItem = require("@ori/basket-item");
var _checkoutQuickOrderForm = require("@ori/checkout-quick-order-form");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _types = require("../types");
var _EmptySection = require("./EmptySection");
var _SectionItem = require("./SectionItem");
var _jsxRuntime = require("react/jsx-runtime");
const SectionMain = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const configuration = (0, _contexts.useCheckoutBasket)();
    const { isQofVisible, isSimplifiedCheckout } = configuration;
    const { shoppingBagItemsValid, shoppingBagItems, distinctOffers, backorderItems, isEmptyBasket } = (0, _contexts.useBasketContext)();
    const { handleFeedbackOpen } = (0, _hooks.useFeedbackNotification)();
    const [replacedItemCode, setReplacedItemCode] = (0, _react.useState)('');
    if (replacedItemCode !== '' && shoppingBagItems.length > 0) {
        var _shoppingBagItems_;
        const isItemPresentCheck = (element)=>element.itemCode === replacedItemCode;
        const isItemPresent = shoppingBagItems.some(isItemPresentCheck);
        if (!isItemPresent && shoppingBagItems.length > 0 && ((_shoppingBagItems_ = shoppingBagItems[0]) === null || _shoppingBagItems_ === void 0 ? void 0 : _shoppingBagItems_.originalProduct)) {
            handleFeedbackOpen(_types.FeedbackNotificationType.Replacement);
            setReplacedItemCode('');
        }
    }
    const handleChangedLineNumber = (0, _react.useCallback)((lineNumber)=>{
        if (lineNumber !== null && shoppingBagItems.length > 0) {
            const resultItem = shoppingBagItems.find((item)=>item.lineNumber === lineNumber);
            if (resultItem) {
                setReplacedItemCode(resultItem.itemCode);
            }
        } else {
            setReplacedItemCode('');
        }
    }, [
        shoppingBagItems
    ]);
    const baseMapperProps = (0, _react.useMemo)(()=>({
            isBundleItem: false,
            isSubscription: false,
            isOfferItem: false
        }), []);
    // items and backorders
    const mainSectionTestId = getTestId('products');
    const mainMapperProps = (0, _react.useMemo)(()=>({
            ...baseMapperProps,
            testId: mainSectionTestId
        }), [
        baseMapperProps,
        mainSectionTestId
    ]);
    const backorderMapperProps = (0, _react.useMemo)(()=>({
            ...baseMapperProps,
            testId: "".concat(mainSectionTestId, "-back-order")
        }), [
        baseMapperProps,
        mainSectionTestId
    ]);
    const actionsProps = (0, _react.useMemo)(()=>({
            placement: _analyticsData.Placement.MainBasket,
            handleFeedbackOpen,
            handleChangedLineNumber
        }), [
        handleChangedLineNumber,
        handleFeedbackOpen
    ]);
    // offers
    const offersTestId = getTestId('offers');
    const offersMapperProps = (0, _react.useMemo)(()=>({
            ...baseMapperProps,
            isOfferItem: true,
            testId: offersTestId
        }), [
        baseMapperProps,
        offersTestId
    ]);
    const offersActionsProps = (0, _react.useMemo)(()=>({
            placement: _analyticsData.Placement.Offers
        }), []);
    if (isEmptyBasket) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [
                isQofVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutQuickOrderForm.App, {
                    configuration: configuration
                }) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_EmptySection.EmptySection, {})
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            isQofVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutQuickOrderForm.App, {
                configuration: configuration
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_basketItem.BasketSection, {
                overrideMdMaxWidth: isSimplifiedCheckout ? undefined : "".concat(_constants.MAX_WIDTH, "px"),
                children: [
                    shoppingBagItemsValid.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_SectionItem.SectionItem, {
                            item: item,
                            mapperProps: mainMapperProps,
                            actionsProps: actionsProps
                        }, "shopping-bag-item-".concat(item.itemCode, "-").concat(item.itemType, "-").concat(item.lineNumber, "-").concat(item.totalPrice))),
                    distinctOffers.map((param)=>{
                        let { choiceId, combineChoiceId, items, offerType, title } = param;
                        return items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_SectionItem.SectionItem, {
                                item: item,
                                mapperProps: offersMapperProps,
                                actionsProps: {
                                    ...offersActionsProps,
                                    combineChoiceId,
                                    offerChoiceId: choiceId
                                }
                            }, "offer-item-".concat(item.itemCode, "-").concat(item.itemType, "-").concat(item.lineNumber, "-").concat(item.totalPrice)));
                    }),
                    backorderItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_SectionItem.SectionItem, {
                            item: item,
                            mapperProps: backorderMapperProps,
                            actionsProps: actionsProps
                        }, "back-order-item-".concat(item.itemCode, "-").concat(item.itemType, "-").concat(item.lineNumber, "-").concat(item.totalPrice)))
                ]
            })
        ]
    });
};
exports.SectionMain = SectionMain;
